import { render, staticRenderFns } from "./AnimationWrapper.vue?vue&type=template&id=49cde4a6&scoped=true"
import script from "./AnimationWrapper.vue?vue&type=script&lang=js"
export * from "./AnimationWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cde4a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49cde4a6')) {
      api.createRecord('49cde4a6', component.options)
    } else {
      api.reload('49cde4a6', component.options)
    }
    module.hot.accept("./AnimationWrapper.vue?vue&type=template&id=49cde4a6&scoped=true", function () {
      api.rerender('49cde4a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/AnimationWrapper.vue"
export default component.exports